var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1688_4127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9945 5.5776C19.4448 4.80747 20.5552 4.80747 21.0055 5.5776L24.1859 11.0166C24.3502 11.2977 24.6241 11.4972 24.9415 11.567L31.0834 12.919C31.9531 13.1104 32.2962 14.1692 31.7049 14.8366L27.5285 19.5501C27.3127 19.7936 27.208 20.1164 27.2399 20.4407L27.8554 26.7152C27.9426 27.6037 27.0443 28.2581 26.2285 27.9004L20.467 25.3744C20.1693 25.2439 19.8307 25.2439 19.533 25.3744L13.7715 27.9004C12.9557 28.2581 12.0574 27.6037 12.1446 26.7152L12.7601 20.4407C12.792 20.1164 12.6873 19.7936 12.4715 19.5501L8.29514 14.8366C7.70379 14.1692 8.04692 13.1104 8.91659 12.919L15.0585 11.567C15.3759 11.4972 15.6498 11.2977 15.8141 11.0166L18.9945 5.5776Z",
    fill: "#FFC53D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1688_4127",
    x: 0.3,
    y: 0.3,
    width: 39.4,
    height: 38.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.42 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1688_4127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1688_4127",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.77916e2bfafb453b8fec0fdd778fdf08.svg";
export { ForwardRef as ReactComponent };